import { SvgIcon, SvgIconProps } from "@mui/material";

export const GlobeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 3.1c4.667 4.927 4.667 12.873 0 17.8M12 20.9C7.333 15.973 7.333 8.027 12 3.1"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 3c4.982 0 9 4.018 9 9s-4.018 9-9 9M12 21c-4.982 0-9-4.018-9-9s4.018-9 9-9M3.51 9h16.98M3.51 15h16.98"
      />
    </svg>
  </SvgIcon>
);
